import { Inject, Injectable } from '@angular/core'
import { TargetTypes } from '../../../generated/chaser/graphql'
import { SBS_ENVIRONMENT } from '../../sbs-common.module'
import { SbsEnvironment } from '../models/sbs-environment'

export interface SbsQRCode {
  invalidQrCode?: boolean
  scienceOrganisationId?: string | null | undefined
  artefactId?: string | null | undefined
  contentElementId?: string | null | undefined
  artefactRouteId?: string | null | undefined
}
export const saveQRCodeKey = 'savedQRCode'
@Injectable({
  providedIn: 'root',
})
export class QrCodeUtilsService {
  constructor() {}

  public saveQrCode(savedQrCode: string): void {
    window.localStorage.setItem(
      saveQRCodeKey,
      JSON.stringify({
        savedQrCode,
        savedTime: new Date(),
      }),
    )
  }

  getSavedQrCode() {
    const qrCodeFromStorage = window.localStorage.getItem(saveQRCodeKey)
    window.localStorage.removeItem(saveQRCodeKey)
    try {
      const qrCode = JSON.parse(qrCodeFromStorage as string)
      if (qrCode.savedTime) {
        const difference = new Date().getTime() - new Date(qrCode.savedTime).getTime()
        if (difference < 3600000) {
          return qrCode.savedQrCode
        }
      }
    } catch (e) {
      return null
    }

    return null
  }

  convertQrCodeStringToUrl(qrCodeString: string) {
    const baseAppUrl = window.location.href.substring(0, window.location.href.indexOf('dtm'))
    return `${baseAppUrl}chaser?qrCode=${qrCodeString}`
  }

  parseSbsQrCodeFromAppUrl(appUrlWithQrCode: string) {
    //codes are always assumed to be 5 characters
    const searchString = '?qrCode='
    return appUrlWithQrCode.substring(
      appUrlWithQrCode.indexOf(searchString) + searchString.length,
      appUrlWithQrCode.indexOf(searchString) + searchString.length + 5,
    )
  }
}
